module.exports = __webpack_public_path__ + "static/img/s23.d99239e5.png";